/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSlotsResult } from '../../models/get-slots-result';

export interface GetSlots$Params {
  LieuId?: number;
  NbPlaces?: number;
  Start?: string;
  End?: string;
  SiteName?: string;
}

export function getSlots(http: HttpClient, rootUrl: string, params?: GetSlots$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSlotsResult>> {
  const rb = new RequestBuilder(rootUrl, getSlots.PATH, 'get');
  if (params) {
    rb.query('LieuId', params.LieuId, {});
    rb.query('NbPlaces', params.NbPlaces, {});
    rb.query('Start', params.Start, {});
    rb.query('End', params.End, {});
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSlotsResult>;
    }),
  );
}

getSlots.PATH = '/Bookings/slots';
